/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Signin1Inputs */

const zh_learn_signin1 = /** @type {(inputs: Learn_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const en_learn_signin1 = /** @type {(inputs: Learn_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_learn_signin1 = /** @type {(inputs: Learn_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Learn_Signin1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_signin1 = /** @type {((inputs?: Learn_Signin1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Signin1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_signin1(inputs)
	if (locale === "en") return en_learn_signin1(inputs)
	return es_learn_signin1(inputs)
});
export { learn_signin1 as "learn_signIn" }